module.exports = __webpack_public_path__ + "img/header-dots-mobile.5968fac3.svg";